<template>
  <div>
    <CCardHeader class="p-0">
      <CRow>
        <CCol col="4" style="text-align: start">

          <strong v-if="status_form==0">{{ $t('components.addProduct') }}</strong>

        </CCol>
        <CCol col="8" style="text-align: end">

          <!--          <CButton class="mr-1" @click="insert_data()" type="primar" size="sm" color="secondary">-->
          <!--            {{ $t('buttons.editPrice') }}-->
          <!--          </CButton>-->

          <CButton class="mr-1" type="reset" size="sm" color="secondary">
            {{ $t("buttons.print") }}
          </CButton>

        </CCol>


      </CRow>
      <!--        </div>-->

      <!-- Right aligned nav items -->
      <!--      </CCollapse>-->
    </CCardHeader>

    <CRow>

      <CCol col="12">
        <CDataTable
            :items="price_items"
            :fields="unit_model_fields"
            border
            :items-per-page="100"
            hover
            :clickableRows="true"
            @row-clicked="table_row_clicked"
            pagination
        >

          <template #buy_price="{item}">
            <td>
              <CInputCurrency class="m-0 p-0  text-price"
                              v-model="item.purchasePrice"
              />
            </td>
          </template>



          <template #porsant="{item}">
            <td>
              <CInputCurrency class="m-0 p-0 text-price"
                              v-model="item.porsant"
              />
            </td>
          </template>


          <template #sell_price-header="{item}">
            <div class="text-center">
              <label class="text-center">{{ $t('tables.sellPrice') }}</label>

            </div>
            <div>
              <div class="text-center" style="width: 100%">
                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33%;border-bottom: 0">{{ $t('customerPrice') }}</label>

                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33%;border-bottom: 0">{{ $t('cashPrice') }}</label>
                <!--                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 25%;border-bottom: 0">{{$t('components.coWorkerPrice')}}</label>-->
                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33%;border-bottom: 0">{{ $t('creditPrice') }}</label>

              </div>
            </div>
            <!--                  <thead>-->

            <!--                  </thead>-->
          </template>

          <template class="text-center" #sell_price="{item}">
            <!--                  <thead>-->
            <td>
              <tr>
                <td style="width: 33%;border-top: 0;padding: 0">
                  <CInputCurrency class="m-0 p-0 text-price"

                                  v-model="item.customerPrice"
                  />
                </td>

                <td style="width: 33%;border-top: 0;padding: 0">
                  <CInputCurrency class="m-0 p-0  text-price"

                                  v-model="item.wholesalePrice"
                  />
                </td>
                <td style="width: 33%;border-top: 0;padding: 0">
                  <CInputCurrency class="m-0 p-0 text-price"
                          v-model="item.retailPrice"
                  />
                </td>

                <!--              <td style="width: 25%;border-top: 0;padding: 0">-->
                <!--              <CInput class="m-0 p-0"-->
                <!--                      v-model="item.coworkerPrice"-->
                <!--              />-->
                <!--            </td>-->


              </tr>
            </td>
            <!--                  </thead>-->
          </template>


          <template class="text-center" #off_percent-header="{item}">
            <div class="text-center">
              <label class="text-center">{{ $t('tables.offPercent') }}</label>

            </div>
            <div>
              <div class="text-center" style="width: 100%">
                <!--                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 33.3%;border-bottom: 0">{{$t('Shreds')}}</label>-->
                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 50%;border-bottom: 0">{{ $t('cashPrice') }}</label>
                <label style="margin-bottom: 0;border: 1px solid;border-color: #d8dbe0;width: 50%;border-bottom: 0">{{ $t('creditPrice') }}</label>

              </div>
            </div>

          </template>

          <template #off_percent="{item}">
            <td>
              <tr>
                <!--              <td style="width: 33.3%;border-top: 0;padding: 0">-->
                <!--                <CInput class="m-0 p-0"-->
                <!--                        v-model="item.retailDiscount"-->
                <!--                />-->
                <!--              </td>-->

                <td style="width: 50%;border-top: 0;padding: 0">
                  <CInputCurrency class="m-0 p-0 text-price"
                                  v-model="item.wholesaleDiscount"
                  />
                </td>
                <td style="width: 50%;border-top: 0;padding: 0">
                  <CInputCurrency class="m-0 p-0 text-price"
                                  v-model="item.retailDiscount"
                  />
                </td>

              </tr>
            </td>
          </template>

          <template #non_off="{item}">
            <td>
              <CInputCheckbox class="text-price"
                              :checked.sync="item.nonOff"
              />
            </td>
          </template>
          <template #operation="{item}">
            <td>
              <CIcon @click.native="insert_data(item)" name="saveNew"
                     class="text-dark"/>
              <CIcon v-if="get_access('product_guild_price')" @click.native="open_guild_price(item)" name="cil-list"
                     class="text-dark"/>
            </td>
          </template>
        </CDataTable>

      </CCol>

      <!--      <CCol col="8" class="mb-5">-->
      <!--        <CCard>-->
      <!--          <CCardHeader class="p-1">-->
      <!--            <strong>{{ $t('components.editProductPrice') }}</strong>-->
      <!--          </CCardHeader>-->

      <!--          <CCardBody>-->

      <!--            <CRow>-->
      <!--              <CCol col="2">-->
      <!--                <CInput-->
      <!--                    :label="$t('components.customerPrice')"-->
      <!--                    :disabled="disable_input"-->
      <!--                    type="number"-->
      <!--                    v-model="customer_price"-->
      <!--                    autocomplete="name"-->
      <!--                />-->
      <!--              </CCol>-->

      <!--              <CCol col="2">-->
      <!--                <CInput-->
      <!--                    :label="$t('components.sellPrice')"-->

      <!--                    type="number"-->
      <!--                    :disabled="disable_input"-->

      <!--                    v-model="sell_price"-->
      <!--                />-->
      <!--              </CCol>-->

      <!--              <CCol col="2">-->
      <!--                <CInput-->
      <!--                    :label="$t('components.commissionPercent')"-->
      <!--                    :disabled="disable_input"-->

      <!--                    type="number"-->

      <!--                    v-model="porsant"-->
      <!--                />-->
      <!--              </CCol>-->

      <!--              <CCol col="2">-->
      <!--                <CSelect-->
      <!--                    :disabled="disable_input"-->

      <!--                    :options="[{label:$t('components.is_percent'),value:true},{label:$t('components.is_price'),value:false}]"-->
      <!--                    :value.sync='off_is_percent'-->
      <!--                    :label="$t('components.percent_status')"-->
      <!--                />-->

      <!--              </CCol>-->
      <!--              <CCol col="2">-->
      <!--                <CInput-->
      <!--                    :label="$t('components.off')"-->
      <!--                    :disabled="disable_input"-->

      <!--                    type="number"-->

      <!--                    v-model="off_amount"-->
      <!--                />-->
      <!--              </CCol>-->

      <!--              <CCol col="2">-->
      <!--                <CInput-->
      <!--                    :label="$t('components.tax')"-->
      <!--                    :disabled="disable_input"-->

      <!--                    type="number"-->

      <!--                    v-model="tax_percent"-->
      <!--                />-->
      <!--              </CCol>-->


      <!--            </CRow>-->
      <!--          </CCardBody>-->
      <!--          &lt;!&ndash;          <CCardFooter>&ndash;&gt;-->
      <!--          &lt;!&ndash;            <CButton :disabled="disable_input"&ndash;&gt;-->
      <!--          &lt;!&ndash;                     @click="insert_data()" type="submit" size="sm" color="warning">&ndash;&gt;-->
      <!--          &lt;!&ndash;              <CIcon size="sm" name="cil-check-circle"/>&ndash;&gt;-->
      <!--          &lt;!&ndash;              {{ $t('buttons.editPrice') }}&ndash;&gt;-->
      <!--          &lt;!&ndash;            </CButton>&ndash;&gt;-->
      <!--          &lt;!&ndash;          </CCardFooter>&ndash;&gt;-->
      <!--        </CCard>-->

      <!--      </CCol>-->
      <!--      <CCol col="4" class="mb-5">-->
      <!--        <CCard v-if="!disable_input">-->
      <!--          <CCardHeader class="p-1">-->
      <!--            <strong>{{ $t('components.saleMethods') }}</strong>-->
      <!--          </CCardHeader>-->

      <!--          <CCardBody>-->
      <!--            <div v-for="method in methods">-->
      <!--              <CInput-->
      <!--                  :label="method.methodTitle"-->

      <!--                  type="number"-->
      <!--                  :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"-->
      <!--                  v-model="method.price"-->
      <!--              >-->
      <!--                <template #append-content>-->
      <!--                  <CIcon v-on:click.native="insert_methods(method)" name="cil-pencil"/>-->
      <!--                </template>-->
      <!--              </CInput>-->


      <!--            </div>-->
      <!--          </CCardBody>-->
      <!--        </CCard>-->
      <!--      </CCol>-->
    </CRow>
    <CRow>

    </CRow>
    <CModal
            :show.sync="dialog_guild_price"
            :no-close-on-backdrop="false"
            color="transparent"
            border-color="primary"
    >

      <div align="center">
<div>
  <CRow v-for="guild_price in item_guild_prices" :key="guild_price.id">
    <CCol col="3">
      {{guild_price.guildUnitName}}
    </CCol>
    <CCol col="3">
     <CInput v-model="guild_price.unitPrice"/>
    </CCol>
    <CCol col="1">
      <CIcon @click.native="insert_guild_price(guild_price)" name="saveNew"
             class="text-dark"/>
    </CCol>

  </CRow>
</div>


      </div>

      <template #footer>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
// import the styles


export default {
  name: 'Login',
  components: {},
  props: {
    items: Array,
    selected_model: Number,
    master_id: Number,
  },
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      customer_price: '',
      sell_price: '',
      porsant: '',
      dialog_guild_price: false,
      off_amount: '',
      tax_percent: '',
      off_is_percent: true,
      details: [],
      methods: [],
      price_items: [],
      collapseDuration: 0,
      disable_input: true,
      status_form: 0,
      status_form_for_guild: 0,
      item_guild_prices:[],

      unit_model_fields: [
        // {key: 'item_code', _show: false, label: 'item Code', _style: 'width:15%;padding:2px'},
        // {key: 'unit', label: this.$t('tables.unit'), _style: 'width:20%;padding:0px'},
        {
          key: 'productCode',
          label: this.$t('components.productBarcode'),
          _style: 'width:10%;padding:0px;text-align:center'
        },

        {key: 'productName', label: this.$t('tables.model'), _style: 'width:15%;padding:0px;text-align:center'},
        {
          key: 'porsant',
          _show: false,
          label: this.$t('visitorPorsant'),
          _style: 'width:5%;padding:0px;text-align:center'
        },
        {key: 'buy_price', _show: false, label: this.$t('buyPrice'), _style: 'width:5%;padding:0px;text-align:center'},
        {key: 'sell_price', _show: false, label: this.$t('sellPrice'), _style: 'width:20%;padding:0px'},
        {key: 'off_percent', _show: true, label: this.$t('tables.offPercent'), _style: 'width:15%;padding:0px'},
        {key: 'non_off', _show: true, label: this.$t('components.nonOffProducts'), _style: 'width:5%;padding:0px'},
        {key: 'operation', label: "", _style: 'width:3%;padding:0px'},

        // {key: 'item_code', _show: false, label: 'خرده', _style: 'width:15%;padding:0px'},
        // {key: 'item_code', _show: false, label: 'عمده', _style: 'width:15%;padding:0px'},

      ],
    }
  },
  computed: {
    // get_items() {
    //   var data = [];
    //   for (var i = 0; i < this.items.length; i++) {
    //     if (i != 0) {
    //       data.push(this.items[i])
    //     }
    //   }
    //   return data;
    // }
  },
  mounted() {

    this.$root.root_validate_errors = [];

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = item.productId;
      }
    });
    this.get_price_methods();
    this.get_product_data();

  }, watch: {
    '$route.params.product_id': function () {
      this.get_product_data();
    },
    'selected_model': function () {
      this.get_price_methods();
      this.get_product_data();
    }
  },
  methods: {
    table_row_clicked(item, index) {
      // this.disable_input = false;
      // this.selected_model = index;
      // this.get_price_methods();
      // this.get_product_data();

    },
    open_guild_price(item){
      this.status_form_for_guild = item.productId;
      this.get_guild_price(item)
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.customer_price != 0) {
        return true;
      }

      if (this.sell_price == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertSellProductPrice'));
      }
      if (this.customer_price == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertCustomerProductPrice'));
      }
      // if (this.porsant == 0) {
      //   this.$root.root_validate_errors.push(this.$t('dialogs.insertCommissionPercent'));
      // }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    insert_guild_price(guild_price) {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);
      formData.append('ProductId', this.status_form_for_guild);
      formData.append('GuildUnitId', guild_price.guildUnitId);
      formData.append('UnitPrice', guild_price.unitPrice);


      axios.post('AddGuildUnitProductPrice', formData, {}).then(function (response) {

        var content_data = response.data;
        self.$root.modal_component.show_api_response_modals(res);

        // items = content_cats.orders;

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_guild_price(item) {
      var self = this;

      const formData = new FormData();

// console.log('item',item)
      // formData.append('id', this.selected_province);
      formData.append('Id', item.productId);


      axios.post('GetGuildUnitProductPrices', formData, {}).then(function (response) {

self.item_guild_prices = response.data.data
        self.dialog_guild_price = true;

        // items = content_cats.orders;


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_price_methods() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.selected_province);
      formData.append('Id', this.selected_model);


      axios.post('GetPriceMethods', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.methods = content_data.data
        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_product_data() {
      console.log("product id 1111" + this.$route.params.product_id);

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetProductNewPriceByMasterId";

      formData.append('ProductMasterId', this.master_id);


      axios.post(url, formData, {}).then((res) => {
        if (res.data.data.length == 0) {
          self.status_form = 0;
        } else {
          self.status_form = res.data.data[0].id;
        }
        self.price_items = res.data.data

      })
          .catch(function (error) {

            console.log(error);
          });


    },

    insert_data(item) {
      // if (!this.validateForm()) {
      //   console.log("validate form is false" + this.validate_errors);
      //   return true;
      // }

      let self = this;
      const formData = new FormData();
      let url;
      // if (this.status_form == 0) {
      url = "AddProductNewPrice";
      // } else {
      //   url = "EditProductNewPrice";
      //   formData.append('id', "0")
      //
      // }

      formData.append('PurchasePrice', item.purchasePrice);
      formData.append('Porsant', item.porsant);
      formData.append('CoworkerPrice', item.coworkerPrice);
      formData.append('RetailPrice', item.retailPrice);
      formData.append('ProductId', item.productId);
      formData.append('ProductMasterId', this.master_id);
      formData.append('WholesalePrice', item.wholesalePrice);
      formData.append('CustomerPrice', item.customerPrice);
      formData.append('CoworkerDiscount', item.coworkerDiscount);
      formData.append('RetailDiscount', item.retailDiscount);
      formData.append('WholesaleDiscount', item.wholesaleDiscount);
      formData.append('NonOff', item.nonOff);


      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);
        // self.get_product_data()


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_methods(method) {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      url = "EditMethod";


      formData.append('MethodId', method.methodId);
      formData.append('Id', method.id);
      formData.append('Price', method.price);
      formData.append('ProductId', this.$route.params.product_id);

      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {

        // self.$root.modal_component.show_api_response_modals(res);
        self.get_price_methods()


      })
          .catch(function (error) {
            console.log(error);
          });

    },


    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    }, delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
